import { SxStyles } from '../../types';
import theme from '../../theme';
import { getResponsiveSize } from '../../utils';

export const ConfirmModalStyle: SxStyles = {
  confirmModal: {
    '&.confirm-modal .modal-wrapper': {
      width: getResponsiveSize(560),
      borderRadius: getResponsiveSize(24),
      overflow: 'hidden',
      backgroundColor: '#FCFCFC',
    },
    [theme.breakpoints.media?.tablet!]: {
      '&.confirm-modal .modal-wrapper': {},
    },
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#FCFCFC',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#517EC5',
    borderBottom: '1px solid #41659E',
    px: getResponsiveSize(24),
    py: getResponsiveSize(16),
  },
  titleText: {
    color: theme.palette.myPrimary?.white,
    fontWeight: 700,
    fontSize: getResponsiveSize(24),
    lineHeight: getResponsiveSize(30),
  },
  content: {
    px: getResponsiveSize(24),
    py: getResponsiveSize(16),
  },
  messageText: {
    color: theme.palette.neutral?.grey70,
    fontSize: getResponsiveSize(16),
    lineHeight: getResponsiveSize(28),
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: getResponsiveSize(16),
    px: getResponsiveSize(16),
    py: getResponsiveSize(12),
  },
};
